class MHeader extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      headers: ["header"],
      logos: [".m-logo"],
      topbar: ".m-topbar",
      headerWrapper: ".m-header__wrapper",
      topbarClose: ".m-topbar__close",
    };
    this.domNodes = queryDomNodes(this.selectors, this);
    this.innerWidth = window.innerWidth;
    this.headerOffsetTop = this.domNodes.headerWrapper.offsetTop;
    this.headerHeight = this.domNodes.headerWrapper.offsetHeight;
    this.stickyHeader = this.dataset.sticky;

    this.classes = {
      scrollUp: "scroll-up",
      scrollDown: "scroll-down",
      stuck: "stuck",
      always: "header-sticky-always",
      headerScrollUp: "header-scroll-up",
      headerScrollDown: "header-scroll-down",
    };
    this.init();
  }

  init() {
    this.transparentHeader =
      this.domNodes && this.domNodes.headers[0] && this.domNodes.headers[0].dataset.transparent === "true";
    this.initAddon();
    this.handleSticky();
    document.addEventListener("matchMobile", () => this.handleSticky());
    document.addEventListener("unmatchMobile", () => this.handleSticky());
    this.siteNav = new SiteNav(this);
    window.__sfHeader = this;
    // handleSticky() measures the announcement bar / topbar once. That runs before
    // the logo image and webfonts lay out, so the first measurement is short and the
    // header pins early — a visible jump. Re-measure once everything has settled.
    window.addEventListener("load", () => this.handleSticky());
    window.addEventListener("resize", () => {
      this.innerWidth = window.innerWidth;
      this.handleSticky();
    });
  }

  initAddon() {
    this.megamenu = new Megamenu(this);
    if (Shopify.designMode) {
      MinimogTheme = MinimogTheme || {};
      MinimogTheme && MinimogTheme.Wishlist && MinimogTheme.Wishlist.updateWishlistCount();
    }
  }
  handleSticky() {
    let extraSpace = 0;
    const sectionGroups = document.querySelectorAll(".shopify-section-group-header-group");
    sectionGroups.forEach((section) => {
      if (!section.classList.contains("m-section-header") && !section.classList.contains("m-section-scaling-logo")) {
        extraSpace += section.offsetHeight;
      }
    });
    const topBar = document.querySelector(".m-topbar");
    if (topBar) extraSpace += topBar.offsetHeight;

    this.headerHeight = this.domNodes.headerWrapper.offsetHeight;

    if (this._onScroll) window.removeEventListener("scroll", this._onScroll);

    // "always" locks the header at the top — it never translates away, so none of the
    // scroll-up/scroll-down bookkeeping below applies. The only thing that changes is
    // pinned vs not, and we write that class only on an actual transition so the
    // wrapper's box-shadow can transition in (header.css) instead of popping.
    // Deliberately not rAF-throttled: the pin threshold has to be evaluated on the
    // same frame as the scroll, or a fast flick leaves the header lagging behind the
    // viewport top for a frame and then snapping into place.
    const lockedSticky = this.stickyHeader === "always";
    let pinned = null;

    let lastScroll = 0;
    this._onScroll = () => {
      const currentScroll = window.scrollY;

      if (lockedSticky) {
        const shouldPin = currentScroll > extraSpace;
        if (shouldPin !== pinned) {
          pinned = shouldPin;
          this.classList.toggle(this.classes.always, shouldPin);
        }
        return;
      }

      if (currentScroll <= extraSpace) {
        this.classList.remove(this.classes.scrollUp, this.classes.stuck, this.classes.always);
        document.body.classList.remove(this.classes.headerScrollUp, this.classes.headerScrollDown);
        return;
      }

      if (this.stickyHeader === "on_scroll_up") {
        this.classList.add(this.classes.stuck);
      }

      if (
        currentScroll > this.headerHeight + extraSpace &&
        currentScroll > lastScroll &&
        !this.classList.contains(this.classes.scrollDown)
      ) {
        this.classList.remove(this.classes.scrollUp);
        document.body.classList.remove(this.classes.headerScrollUp);
        this.classList.add(this.classes.scrollDown);
        document.body.classList.add(this.classes.headerScrollDown);
      } else if (currentScroll < lastScroll && this.classList.contains(this.classes.scrollDown)) {
        this.classList.remove(this.classes.scrollDown);
        document.body.classList.remove(this.classes.headerScrollDown);
        this.classList.add(this.classes.scrollUp);
        document.body.classList.add(this.classes.headerScrollUp);
      }
      lastScroll = currentScroll;
    };
    window.addEventListener("scroll", this._onScroll, { passive: true });
    // Apply the correct state right away: this also runs on load/resize, when the page
    // may already be scrolled past the threshold.
    this._onScroll();
  }
}
customElements.define("m-header", MHeader);

// Header links use the same session hint as the storefront wishlist/checkout.
// Shopify's Liquid `customer` does not reflect the Surma account cookie.
(() => {
  const apiBaseUrl = window.SurmaConfig?.apiBaseUrl ||
    window.MinimogSettings?.surmaApiBaseUrl || "https://dev.api.surma.in";
  const sessionKey = "surma_web_session:" + new URL(apiBaseUrl).origin;

  function syncAccountMenu() {
    let signedIn = false;
    try {
      signedIn = Boolean(localStorage.getItem(sessionKey)?.trim());
    } catch {
      // Keep login accessible when storage is blocked.
    }

    document.querySelectorAll(".m-header a[href], #m-menu-drawer a[href]").forEach((link) => {
      if (
        link.origin !== window.location.origin ||
        !/\/pages\/my-account\/?$/.test(link.pathname) ||
        link.hash !== "#/login"
      ) {
        return;
      }

      const item = link.closest("li") || link;
      item.setAttribute("data-account-login", "");
      item.hidden = signedIn;
    });
  }

  // Identity notifications can precede synchronous session-flag cleanup.
  const scheduleSync = () => queueMicrotask(syncAccountMenu);
  window.addEventListener("surma:identity-changed", scheduleSync);
  window.addEventListener("surma:session-expired", scheduleSync);
  window.addEventListener("storage", (event) => {
    if (event.key === sessionKey || event.key === null) scheduleSync();
  });
  window.addEventListener("pageshow", scheduleSync);
  window.addEventListener("focus", scheduleSync);
  document.addEventListener("shopify:section:load", scheduleSync);
  syncAccountMenu();
})();
